<template>
    <div>
      <upload-document-form :formSchema="formSchema" @reloadData="close"></upload-document-form>
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
              
              <!-- Confirmation delete box -->
        <v-layout row justify-center>
            <v-dialog v-model="confirmModel" max-width="290">
                <v-card>
                    <v-card-text>Are you sure you want to delete this data?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- /Confirmation delete box -->
     <v-container>
 <v-card>
    <v-card-title>
	<span class="headline">Upload Document List</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      
    >
    <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ ++(props.index) }}</td>
            <td class="text-xs-left">{{ props.item.document_name }}</td>
            <td class="text-xs-left"><a :href="`${public_path}${props.item.document_file_name}`" target="_blank" rel="noopener noreferrer" download="">
                <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>
                
                </a></td>
           
            <td class="justify-center layout px-0">
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
                    <v-icon color="pink">delete</v-icon>
                </v-btn>
            </td>

        </template> 

       <template slot="no-data" class="error">
          <div align="center">No Data Found</div>
        </template>
    </v-data-table>
      <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!--> 
  </v-card>
     </v-container>
     
    </div>
</template>
<script>
const commonService = require('../../services/common.service');

import {preFix} from '../../vuex/api'
import UploadDocumentForm from './upload_document_form'
import ServerPath from "../../server-path/server-path";
import Axios from 'axios'
export default {
    components:{
        UploadDocumentForm
    },
    data: () => ({
      showForm : false,
      valid: true,
      dialog: false,
      dialogEditForm:false,
      publicPath:'',
      formSchema:{
        id:'',
		    record_id:'',
		    sub_menu_id:'',
		    document_name:'',
		    document_file_name:''
	  },

      search: '',
      totalItems: 0,      
      loading: true,

      pagination: {
        sortBy: 'id',
        descending:true,
      },
      
      selected:[],
      search:'',      
      headers: [
		{
			text: 'Sl#',
			align: 'left',
			sortable: false,
			value: 'id'
		},
		{
			text: 'Document Title',
			
			sortable: false,
			value: 'document_name'
        },
        {
			text: 'Download',
			
			sortable: false,
			value: ''
		},
		{ text: 'Actions', value: '', align: 'center', },
		
		],
      items: [],
      
      item: {           
        edit: false,               
        head_id:'',
        related_account:'',
        name:'',
      },
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',
      confirmModel: false,
      select: null,
      adminTypelist:[
        {id:1, name:'DIA'},
        {id:3, name:'Institute'},
      ],

     SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    }),

    computed: {
      userRole() {
                let role = this.$store.getters.get_USER_ROLE_DATA;               
                this.showForm = role.saveButton
                return role;
            }
    },
    created(){
         this.public_path =
         ServerPath.serverPath;
    },

    methods: {

        getAllDocuments(){
			commonService.getAllData('get_all_documents').then( res => {        
			this.items = res.data
			// console.log(this.subMenuList)
			});
		},

       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {

      },
      reloadData(){
        this.showForm = this.userRole.saveButton;
        this.getAllDocuments()
        this.message = 'Data reloaded successfully!'
        this.snackbar = true
        this.formSchema = {
			id:'',
			record_id:'',
			sub_menu_id:'',
			document_name:'',
			document_file_name:''
			}	
      },

     editItem (item) {
        this.formSchema = item;
        console.log("edit",this.formSchema)
				this.showForm = true
				window.scrollTo({ // scroling to top
						top: 0,
						left: 100,
						behavior: "smooth"
					});
			},
			deleteItem (index,id) {          
				this.row_index = index;
				this.delete_id = id;                
				this.confirmModel = true;
			},

			confirmDelete(row_index,id){                    
				commonService.deleteRow(id, 'document-delete').then(res => {
					if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.getAllDocuments();
        } else {
          this.SnackbarVal.color = "error";
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
				});       
			},

			close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.items.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          let findindex = this.items.findIndex(
            (item) => item.id == res.data.id
          );
          this.row_index = findindex;
          this.$set(this.items, this.row_index, { ...res.data });
          this.row_index = "";
          this.formSchema.id = 0;
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }

      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    },

    },

    mounted () {
      this.getAllDocuments();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/document_management/upload_document_list.vue